import request from '@/helpers/request'
import Vue from 'vue'
import full_name from '@/helpers/full_name'

export default {
  GET_USERS_FOR_AUTOCOMPLETE(context, params) {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.users.search}`,
      {
        params: {
          name: params,
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        return _.map(response.data.data.items.data, user => {
          user.name = full_name.by(user, void 0, true)
          return user
        })
      } else {
        throw response
      }
    })
  },
}
